// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useRef } from 'react'
import './EditLicensedStatesDropdown.scss'
import classNames from 'classnames'
import { MultiSelectDropdown } from 'ui_kit_qmd'
import { generateStatesAbbrArrayFromStateFullNamesArray } from '../../../../../utils/common'

const EditLicensedStatesDropdown = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ className, availableStates, setAvailableStates, availableStatesDropdownError }) => {
    const dropdownRef = useRef('')
    const dropdownEmptyCondition = useMemo(
      () => (availableStates?.length ? 'fit-content' : 70),
      [availableStates?.length],
    )
    const dropdownInputValue = useMemo(
      () =>
        generateStatesAbbrArrayFromStateFullNamesArray(
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          availableStates.filter((item) => item?.isActive).map((item) => item.value),
        )
          .sort()
          .join('; '),
      [availableStates],
    )

    useEffect(() => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      dropdownRef.current.onSetValue(dropdownInputValue)
    }, [availableStates, dropdownInputValue])

    const dropdownContainerStyle = useMemo(
      () => ({
        height: availableStates?.length <= 3 ? dropdownEmptyCondition : 190,
        marginTop: 8,
      }),
      [availableStates?.length, dropdownEmptyCondition],
    )
    return (
      <div className={classNames('edit-licensed-states-dropdown-container', {}, [className])}>
        <MultiSelectDropdown
          ref={dropdownRef}
          isRequired
          isWithOptionsSort
          isWithSearch={!!availableStates.length}
          isFlexible
          customEmptyMessage='No applicable states'
          dropdownContainerStyle={dropdownContainerStyle}
          label='Applicable state(s)'
          options={availableStates}
          setOptions={setAvailableStates}
          dropId='licensedStatesDropdown'
          isError={availableStatesDropdownError}
          localError={availableStatesDropdownError}
        />
      </div>
    )
  },
)

export default EditLicensedStatesDropdown
